import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SettingService {
  constructor(public http : HttpClient) { }
  baseUrl = environment.baseUrl

  changePassword(obj:any,token:any){
    var httpOptions;
    httpOptions = {
      headers: new HttpHeaders({
        "accessToken":token,
        "Content-Type":"application/json"
      })
    }
    return this.http.post(this.baseUrl + `adminChangePassword`,obj, httpOptions);
  }

}
